/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hood_Edge_TitleInputs */

const en_hood_edge_title = /** @type {(inputs: Hood_Edge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the edge`)
};

/**
* | output |
* | --- |
* | "On the edge" |
*
* @param {Hood_Edge_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const hood_edge_title = /** @type {((inputs?: Hood_Edge_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hood_Edge_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hood_edge_title(inputs)
});